import React from 'react';

import {
  StyledAttorneySection,
  StyledSectionTitle,
  StyledAttorneyList,
  StyledAttorneyItemContainer,
  StyledAttorneyItemSpan,
} from '../style';

interface IProps {
  party: string[];
}

const SectionParty: React.FC<IProps> = (props: IProps) => {
  return (
    <StyledAttorneySection>
      <StyledSectionTitle>Party</StyledSectionTitle>
      <StyledAttorneyList>
        {props.party.map((item: string) => {
          return (
            <StyledAttorneyItemContainer key={item}>
              <StyledAttorneyItemSpan>{item}</StyledAttorneyItemSpan>
            </StyledAttorneyItemContainer>
          );
        })}
      </StyledAttorneyList>
    </StyledAttorneySection>
  );
};

export default SectionParty;
